<template>
  <div class="backup">
    微信版本太低，请升级微信客户端重新访问。
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  mounted(){

  },
  computed:{

  },
  methods:{

  },
}
</script>
<style scoped>
.backup{
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.35rem;
}
</style>
